'use client';

import { useLanguage } from '@/contexts/LanguageContext';
import Icon from '@/components/ui/AppIcon';

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();

  const toggleLanguage = () => {
    setLanguage(language === 'en' ? 'ar' : 'en');
  };

  return (
    <button data-component-id="src/components/common/LanguageSwitcher.tsx:14:4" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="14" data-component-end-line="21" data-component-file="LanguageSwitcher.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%2C%22className%22%3A%22flex%20items-center%20space-x-2%20px-3%20py-2%20rounded-lg%20font-medium%20text-sm%20transition-all%20duration-300%20text-text-primary%20hover%3Abg-surface%20hover%3Atext-primary%22%7D"
      onClick={toggleLanguage}
      className="flex items-center space-x-2 px-3 py-2 rounded-lg font-medium text-sm transition-all duration-300 text-text-primary hover:bg-surface hover:text-primary"
      aria-label="Switch language"
    >
      <Icon data-component-id="src/components/common/LanguageSwitcher.tsx:19:6" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="19" data-component-end-line="19" data-component-file="LanguageSwitcher.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%2C%22name%22%3A%22LanguageIcon%22%7D" name="LanguageIcon" size={18} variant="outline" />
      <span data-component-id="src/components/common/LanguageSwitcher.tsx:20:6" data-component-path="src/components/common/LanguageSwitcher.tsx" data-component-line="20" data-component-end-line="20" data-component-file="LanguageSwitcher.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22font-semibold%22%7D" className="font-semibold">{language === 'en' ? 'العربية' : 'English'}</span>
    </button>
  );
};

export default LanguageSwitcher;